//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import { mapActions } from "vuex";

export default {
    name: "ImportPluginDialog",
    components: {
        AQDialog,
        AQUploader
    },
    props: {
        showUpload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pluginFile: null,
            importPlugin: true,
            disableBtn: true
        };
    },
    methods: {
        ...mapActions("admin", ["actImportPlugin"]),
        importSelectedPlugin() {
            const pluginData = new FormData();
            pluginData.append("file", this.pluginFile);
            this.actImportPlugin(pluginData).then(
                () => {
                    this.$emit("reloadList");
                    this.pluginFile = null;
                    this.showNotify();
                    this.$emit("closeUpload");
                }
            )
                .catch(() => {
                    this.showNotify(true);
                    this.pluginFile = null;
                    this.$emit("closeUpload");
                });
        },
        showNotify(error) {
            this.$toast.showNotify({
                type: error ? "error" : "success",
                message: this.$t(`plugins.${error ? "errorNotif" : "successNotif"}`)
            });
        },
        onPluginImportSelected(data) {
            if (data.length) {
                [this.pluginFile] = data;
                this.disableBtn = false;
            } else {
                this.pluginFile = null;
                this.disableBtn = true;
            }
        },
        removeFile() {
            this.disableBtn = true;
            this.pluginFile = null;
        },
        cancelImport() {
            this.pluginFile = null;
            this.$emit("closeUpload");
        }
    }
};
